import "./InnerBanner.css";
import defaultBgImage from "../assets/hero-removebg-preview.png";
import { CalendarCheck, Phone } from "lucide-react";
import { triggerBookingPopup } from "./Header";

const PHONE_NUMBER = "8050731754";

const InnerBanner = ({
  title,
  bgImage,
  fullHeight = false,
  brand = "default",
  showActions = false,
}) => {

  const bannerImage = bgImage || defaultBgImage;

  return (
    <div
      className={`inner-banner ${brand}-banner ${
        fullHeight ? "full-height" : ""
      }`}
      style={{ backgroundImage: `url(${bannerImage})` }}
    >
      <div className="inner-overlay">
        <div className="inner-content">
          <h1>{title}</h1>
          {showActions ? (
            <div className="inner-banner-actions">
              <button type="button" onClick={triggerBookingPopup}>
                <CalendarCheck size={18} strokeWidth={2.4} />
                <span>Book Service</span>
              </button>
              <a href={`tel:${PHONE_NUMBER}`}>
                <Phone size={18} strokeWidth={2.4} />
                <span>{PHONE_NUMBER}</span>
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InnerBanner;
